// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Index_wrapper__NuUSz","titleWrapper":"Index_titleWrapper__UymEn","button":"Index_button__RsieF","cardBlocks":"Index_cardBlocks__KwCMm"};